import React from "react";
import theme from "./theme";
import { faLock } from "@fortawesome/fontawesome-free-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const Overlay = ({ overlayText, children }) => (
    <div className={"overlay-container"}>
        <div className={"overlay"}>
            <div className={"overlay-sub-container"}>
                <div className={"overlay-text"}>{overlayText}</div>
            </div>
        </div>
        {children}
        <style jsx>{`
            .overlay-container {
                position: relative;
            }

            .overlay {
                position: absolute;
                height: 100%;
                width: 100%;
                padding: 1rem;
                z-index: 2;
                pointer-events: unset;
                background-color: rgba(255, 255, 255, 0.9);
            }

            .overlay-sub-container {
                position: relative;
                width: 100%;
                height: 100%;
            }

            .overlay-text {
                top: 1rem;
                position: sticky;
                padding: 2rem;
                width: 100%;
                border: 1px solid ${theme.colour.gray300};
                background-color: ${theme.colour.white};
                box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05),
                    0 1px 1px 0 rgba(0, 0, 0, 0.05),
                    0 2px 1px -1px rgba(0, 0, 0, 0.05);
                -webkit-font-smoothing: antialiased;
            }
        `}</style>
    </div>
);

export const OverlayPermissionText = ({ message }) => (
    <div className={"overlay-permission-text"}>
        <div className={"lock-icon"}>
            <FontAwesomeIcon icon={faLock as IconProp} />
        </div>
        <div>{message}</div>
        <style jsx>{`
            .overlay-permission-text {
                display: flex;
                flex-wrap: wrap;
                flex-direction: row;
                font-size: 1.2rem;
            }
            .lock-icon {
                margin-right: 2rem;
                font-size: 2rem;
                color: ${theme.colour.danger};
            }
        `}</style>
    </div>
);

export default Overlay;
